import * as React from 'react'

import { isMacOs } from 'react-device-detect'

import { Button } from '~/client/src/shared/components/Button/Button'
import { Kbd } from '~/client/src/shared/components/shadcn-ui/kbd'
import Spinner from '~/client/src/shared/components/Spinner/Spinner'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// Both ⌘+Enter and Ctrl+Enter fire submit (see the store's keydown); the keycap
// just shows the glyph the current platform expects.
const SUBMIT_SHORTCUT = isMacOs ? '⌘↵' : 'Ctrl↵'

interface IProps {
  canSubmit: boolean
  isSubmitting: boolean
  onCancel: () => void
  onSubmit: () => void
  // Keyboard dismissal on tap is the call site's job, composed into onCancel/onSubmit.
  isMobileEnv?: boolean
}

const ComposerFooter: React.FC<IProps> = ({
  canSubmit,
  isSubmitting,
  onCancel,
  onSubmit,
  isMobileEnv,
}) => (
  <div
    className={
      isMobileEnv
        ? 'tw:flex tw:flex-1 tw:items-center tw:gap-2'
        : 'tw:flex tw:items-center tw:justify-end tw:gap-3'
    }
  >
    <Button
      variant="outline"
      onClick={onCancel}
      // The in-flight create is neither abortable nor idempotent — lock the whole
      // footer while it runs (product convention: PickerCreationPanel, ResourceEdit).
      disabled={isSubmitting}
      className={isMobileEnv ? 'tw:flex-1' : undefined}
      data-testid="workflow-composer-cancel"
    >
      {Localization.translator.cancel}
    </Button>
    <Button
      onClick={onSubmit}
      disabled={!canSubmit || isSubmitting}
      className={isMobileEnv ? 'tw:flex-1' : undefined}
      data-testid="workflow-composer-submit"
    >
      {isSubmitting && (
        <span data-icon="inline-start" className="tw:inline-flex">
          <Spinner size="sm" variant="white" />
        </span>
      )}
      {Localization.translator.submit_verb}
      {!isMobileEnv && (
        <Kbd
          data-icon="inline-end"
          className="tw:bg-background/20 tw:text-background"
        >
          {SUBMIT_SHORTCUT}
        </Kbd>
      )}
    </Button>
  </div>
)

export default ComposerFooter
